import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const LocationIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
  </svg>
);

const PhoneIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75a2.25 2.25 0 012.25-2.25h2.25A.75.75 0 017.5 5.25v2.25a.75.75 0 01-.22.53l-1.5 1.5a16.5 16.5 0 008.47 8.47l1.5-1.5a.75.75 0 01.53-.22h2.25a.75.75 0 01.75.75v2.25a2.25 2.25 0 01-2.25 2.25A15.75 15.75 0 012.25 6.75z" />
  </svg>
);

const TrainIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
  </svg>
);

const BusIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
  </svg>
);

const CarIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0M2.25 8.25h19.5M2.25 8.25L4 5a2 2 0 011.79-1.107h12.42A2 2 0 0120 5l1.75 3.25M2.25 8.25h19.5v5a1.5 1.5 0 01-1.5 1.5H3.75a1.5 1.5 0 01-1.5-1.5v-5z" />
  </svg>
);

const ExternalIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M14 5h5v5m0-5L10 14M5 5h4m-4 0v14h14v-4" />
  </svg>
);

const DirectionsPage = () => {
  const directions = [
    {
      icon: <TrainIcon />,
      title: 'By Subway',
      description:
        'Take the 4 or 6 train to 125th St / Lexington Ave, then walk 5 blocks south on Lexington to 120th Street.',
    },
    {
      icon: <BusIcon />,
      title: 'By Bus',
      description:
        'The M101, M102, and M103 stop on 3rd Avenue at 120th Street, steps from the school entrance.',
    },
    {
      icon: <CarIcon />,
      title: 'By Car',
      description:
        'Street parking on 120th Street and surrounding blocks. The FDR Drive 116th Street exit is closest.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main id="main-content" className="pt-0">
        {/* Hero */}
        <section
          className="relative pt-36 pb-20 bg-[#00213a] overflow-hidden"
        >
          <div
            className="pointer-events-none absolute inset-x-0 bottom-0"
            style={{ height: '4rem', background: 'linear-gradient(to bottom, rgba(0,33,58,0) 0%, rgba(255,255,255,1) 100%)' }}
            aria-hidden="true"
          />

          <div className="max-w-6xl mx-auto px-6 lg:px-8 text-center">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
                <LocationIcon />
                <span className="text-sm font-semibold text-white tracking-tight">
                  Find Us
                </span>
              </div>
            </div>
            <h1
              className="text-5xl lg:text-7xl font-semibold text-white mb-6 tracking-tight"
              style={{ letterSpacing: '-0.02em' }}
            >
              Directions to P.S. 96 ACT
            </h1>
            <p className="text-2xl text-white/90 font-normal max-w-3xl leading-relaxed mb-8 mx-auto">
              216 E 120th Street, New York, NY 10035 — in the heart of East
              Harlem.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=216+E+120th+St+New+York+NY+10035"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white text-[#00213a] font-semibold rounded-lg hover:bg-gray-50 transition-all duration-200 shadow-sm"
              >
                Get Directions on Google Maps <ExternalIcon />
              </a>
            </div>
          </div>
        </section>

        {/* Map + Contact */}
        <section className="max-w-7xl mx-auto px-6 lg:px-8 mt-12 mb-20">
          <div className="grid lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2 bg-white border border-gray-200 rounded-xl shadow-md overflow-hidden">
              <div className="relative pb-[56.25%] h-0">
                <iframe
                  title="PS 96 ACT Location Map"
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://www.google.com/maps?q=216+E+120th+St,+New+York,+NY+10035&output=embed"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl shadow-md p-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <div className="w-10 h-10 rounded-lg bg-[#fdbb2e]/10 flex items-center justify-center text-[#00213a]">
                  <LocationIcon />
                </div>
                School Address
              </h2>
              <address className="not-italic text-gray-700 space-y-1">
                <p className="font-semibold text-gray-900">
                  Joseph C. Lanzetta School of the Arts, Collaboration &amp;
                  Technology
                </p>
                <p>216 E 120th Street</p>
                <p>New York, NY 10035</p>
              </address>

              <div className="mt-6 pt-6 border-t border-gray-200 space-y-3 text-sm">
                <div className="flex items-center gap-3 text-gray-800">
                  <PhoneIcon />
                  <div>
                    <div className="font-semibold">Main Office</div>
                    <a
                      href="tel:+12128605851"
                      className="text-[#00213a] hover:underline"
                    >
                      (212) 860-5851
                    </a>
                  </div>
                </div>
                <div className="flex items-center gap-3 text-gray-600">
                  <PhoneIcon />
                  <div>
                    <div className="font-semibold text-gray-700">Fax</div>
                    <span>(212) 860-6074</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Transit directions */}
        <section className="bg-gray-50 py-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="mb-12">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-lg border border-gray-200 mb-4">
                <TrainIcon />
                <span className="text-sm font-semibold text-gray-700 tracking-tight">
                  Getting Here
                </span>
              </div>
              <h2
                className="text-4xl font-semibold text-gray-900 mb-4 tracking-tight"
                style={{ letterSpacing: '-0.02em' }}
              >
                Ways to Reach the School
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl">
                The school is easily accessible by subway, bus, and car.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {directions.map((d) => (
                <div
                  key={d.title}
                  className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-md hover:border-[#fdbb2e]/40 transition-all duration-200"
                >
                  <div className="w-12 h-12 rounded-lg bg-[#fdbb2e]/10 flex items-center justify-center text-[#00213a] mb-4">
                    {d.icon}
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {d.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed text-sm">
                    {d.description}
                  </p>
                </div>
              ))}
            </div>

            <p className="text-xs text-gray-500 mt-8 text-center italic">
              Transit details are general guidance. Please verify your route
              with the MTA Trip Planner before traveling.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default DirectionsPage;
